import src from "IMAGE";
export default { src, width: 1294, height: 453, blurWidth: 0, blurHeight: 0};
